
import './App.css';
import Dictionary from './Dictionary'

function App() {
  return (
    <div className="App">
      <div className='container'>
      <header className="App-header">  
      ⁜Dictionary for Shecodes⁜
      </header>
      <main>
        <Dictionary defaultKeyword={"freedom"} />
      </main>
      <footer className='footer'>Coded by Negin👩</footer>
      </div>
    </div>
  );
}

export default App;
